module.exports = __webpack_public_path__ + "static/media/Publication_Count.4dc7ea49.png";